export const DELETE_CASE_CONFIRM = 'delete-case-confirm';
export const DELETE_CASE_FILES_CONFIRM = 'delete-case-files-confirm';
export const DELETE_USER_TOOLKIT_PROMPT_CONFIRM = 'delete-user-toolkit-prompt-confirm';
export const DELETE_CHAT_CONFIRM = 'delete-chat-confirm';
export const DELETE_AERIAL_CONFIRM = 'delete-aerial-confirm';
export const RUN_AERIAL_CONFIRM = 'run-aerial-confirm';
export const DISCARD_CREATE_CASE_FROM_FILES_CONFIRM = 'discard-create-case-from-files-confirm';
export const DISCARD_CREATE_PROJECT_CONFIRM = 'discard-create-project-confirm';
export const DELETE_PROJECT_CONFIRM = 'delete-project-confirm';
export const DELETE_PROJECT_FILES_CONFIRM = 'delete-project-files-confirm';
export const BULK_DELETE_MATTERS_CONFIRM = 'bulk-delete-matters-confirm';
